module.exports = __webpack_public_path__ + "img/poker-s12.dbf49636.svg";